import { useEffect } from "react";

export const useLayoutEffects = ({ sendMyMethod }) => {
    useEffect(() => {
        // sendMyMethod({ sample: "new" });
    }, []);

    return {};
};
